module.exports = __webpack_public_path__ + "static/media/setup-top.d44a2555.jpg";